/* Juverto -- scroll motion. [data-juv-rise] and [data-juv-parallax]
 *
 * ============================================================
 * TIMINGS TAKEN FROM chanel.com/us/skincare/le-lift
 * ============================================================
 *
 * Read out of their stylesheets, not guessed:
 *
 *   .zoom__img-container   animation: zoomFadeIn 1.7s ease-in-out forwards
 *   .zoom-fade-out-img     animation: 0.325s ease-in-out forwards
 *   .flatpickr .open       animation: fpFadeInDown 0.3s
 *                          cubic-bezier(0.23, 1, 0.32, 1)
 *   @keyframes fpFadeInDown  0%   opacity 0, translate3d(0,-20px,0)
 *                            100% opacity 1, translateZ(0)
 *   @keyframes zoomFadeIn / centerAppear   pure opacity 0 -> 1
 *
 * Two things carry over. Their easing is cubic-bezier(0.23, 1, 0.32, 1),
 * a hard decelerate that never overshoots, and their image work is SLOW --
 * 1.7 seconds on a fade. Nothing on that page snaps. The previous pass
 * here ran 700ms on a springier curve and read cheap next to it, so:
 *
 *   rise distance   28px
 *   duration        1100ms
 *   easing          cubic-bezier(0.23, 1, 0.32, 1)
 *   text beat       180ms after its image
 *   stagger         120ms per sibling, capped at 3 steps
 *   accordion open  550ms on the same curve
 *
 * ============================================================
 * PARALLAX IS A TRANSLATE, NEVER A SCALE
 * ============================================================
 *
 * Chanel marks two images with data-img-parallax -- .dp__hero_img
 * 1263x854 and .dp__cover_img 1263x1227 -- each object-fit:cover inside
 * an overflow:hidden parent, so the image overflows its frame and slides
 * within it. That works because those are wide editorial photographs
 * with no single subject to lose.
 *
 * OURS ARE NOT. Every Juverto product image is a centred packshot on
 * cream, 2500x2500 square. Overflowing and sliding one WILL cut the top
 * or bottom off the product, which is the exact fault being fixed. So
 * the parallax here is a small translateY ONLY -- no scale, no overflow
 * -- and it travels inside the band's own padding, so the image never
 * reaches an edge. Default +/-16px across a full traverse.
 *
 * Chanel's own product shots, as opposed to their editorial ones, are
 * fitted the same way: .dp__line_img box 255x453 against a natural
 * 573x1018, .dp__resort_img 316x568 against 718x1278 -- the frame is
 * built to the photograph's aspect ratio, so there is nothing to crop.
 *
 * ============================================================
 * WHY NO IntersectionObserver, AND THREE TRIGGERS
 * ============================================================
 *
 * The observer is frame-driven, so it silently delivers nothing when
 * frames stop -- which is how three bands once shipped invisible.
 * Reveals run off a passive scroll listener, a resize listener and a
 * bounded 300ms poll, any ONE of which is sufficient. Parallax adds rAF
 * purely for smoothness; if rAF never fires the images simply sit
 * untranslated, which is a still image rather than a broken one.
 *
 * ============================================================
 * THE VENDOR WATCHDOG -- [reveal-on-scroll], NOT OURS
 * ============================================================
 *
 * Prestige has its own reveal system on a DIFFERENT attribute, and it is
 * the one the collection grid uses. Every .product-card ships as
 * <div class="product-card" reveal-on-scroll="true">, hidden by two
 * rules in assets/theme.css:
 *
 *   @media (prefers-reduced-motion: no-preference) {
 *     [reveal-on-scroll="true"] { opacity: 0 }
 *   }
 *   @media (scripting: none) {
 *     [reveal-on-scroll="true"] { opacity: 1 }
 *   }
 *
 * Those two guards are real and they work. Scripting off -> visible.
 * Reduced motion -> never hidden in the first place. The grid genuinely
 * does render without JavaScript; that was checked before this was
 * written.
 *
 * THE GAP is the third case, which neither guard covers: scripting is
 * ENABLED, the stylesheet applies, and the observer in theme.js never
 * delivers -- because theme.js 404s, throws before it wires up, is
 * delayed behind a slow app script, or runs somewhere frames do not.
 * (scripting: none) does not match a script that merely FAILED. Measured
 * on /collections/best-sellers: scripting enabled, IntersectionObserver
 * present as a function, five cards laid out correctly at 256x325 with
 * their real text -- and computed opacity 0, indefinitely. Blank cream
 * where the products should be.
 *
 * So the same three triggers that drive [data-juv-rise] also watch
 * [reveal-on-scroll]. If an element is in view and STILL computes to
 * opacity 0 after GRACE_MS, it is un-hidden inline. Below-fold cards are
 * left alone so the vendor animation still plays normally when it is
 * working; they get caught on the way in by the scroll listener if it is
 * not.
 *
 * This file is deliberately separate from theme.js, which is the whole
 * point -- a theme.js failure is exactly the scenario being covered, so
 * the rescue cannot live inside it.
 */
(function () {
  var REDUCED =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Long enough that a healthy vendor reveal always wins the race and the
     rescue is never visible; short enough that a broken one is invisible
     for well under two seconds. */
  var GRACE_MS = 1500;
  var BOOTED_AT = Date.now();

  var css = [
    ".juv-motion [data-juv-rise]{opacity:0;transform:translateY(28px)}",
    ".juv-motion [data-juv-rise].juv-risen{opacity:1;transform:none;" +
      "transition:opacity 1.1s cubic-bezier(.23,1,.32,1)," +
      "transform 1.1s cubic-bezier(.23,1,.32,1);" +
      "transition-delay:var(--juv-d,0ms)}",
    ".juv-bbacc__panel{overflow:hidden;height:0;opacity:0;" +
      "transition:height .55s cubic-bezier(.23,1,.32,1),opacity .55s cubic-bezier(.23,1,.32,1)}",
    ".juv-bbacc__item[open] .juv-bbacc__panel{opacity:1}",
    "[data-juv-parallax]{will-change:transform}",
    /* The rescue class. Wins over theme.css because of the extra
       attribute in the selector, without needing !important. */
    "[reveal-on-scroll][data-juv-rescued]{opacity:1!important;" +
      "transform:none!important;" +
      "transition:opacity .45s cubic-bezier(.23,1,.32,1)}",
    "@media (prefers-reduced-motion:reduce){" +
      ".juv-motion [data-juv-rise]{opacity:1!important;transform:none!important;transition:none!important}" +
      ".juv-bbacc__panel{transition:none!important}" +
      "[data-juv-parallax]{transform:none!important}}"
  ].join("");

  var style = document.createElement("style");
  style.setAttribute("data-juverto-motion", "");
  style.textContent = css;
  document.head.appendChild(style);

  if (REDUCED) return;

  document.documentElement.classList.add("juv-motion");

  var armed = [];
  var para = [];
  var vendor = [];
  var poll = null;

  /* Prestige's reveal, watched rather than driven. Anything still at
     opacity 0 while it is on screen, past the grace period, is rescued.
     Reading getComputedStyle here is deliberate: it is the only way to
     tell "the observer has not fired yet" from "the observer is never
     going to fire", because both look identical in the DOM. */
  function rescue() {
    if (!vendor.length) return;
    if (Date.now() - BOOTED_AT < GRACE_MS) return;
    var vh = window.innerHeight;
    for (var i = vendor.length - 1; i >= 0; i--) {
      var el = vendor[i];
      var r = el.getBoundingClientRect();
      if (r.top > vh || r.bottom < 0) continue;
      if (parseFloat(getComputedStyle(el).opacity) < 0.01) {
        el.setAttribute("data-juv-rescued", "");
      }
      vendor.splice(i, 1);
    }
  }

  function check() {
    var trigger = window.innerHeight * 0.9;
    for (var i = armed.length - 1; i >= 0; i--) {
      var n = armed[i];
      var r = n.getBoundingClientRect();
      if (r.top < trigger && r.bottom > 0) {
        n.classList.add("juv-risen");
        armed.splice(i, 1);
      }
    }
    rescue();
    if (!armed.length && !para.length && !vendor.length && poll) {
      clearInterval(poll);
      poll = null;
    }
  }

  function paint() {
    var vh = window.innerHeight;
    for (var i = 0; i < para.length; i++) {
      var el = para[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) continue;
      var amt = parseFloat(el.getAttribute("data-juv-parallax")) || 16;
      /* -1 entering from below, +1 leaving above */
      var p = (vh / 2 - (r.top + r.height / 2)) / ((vh + r.height) / 2);
      if (p > 1) p = 1;
      if (p < -1) p = -1;
      el.style.transform = "translateY(" + (p * amt).toFixed(1) + "px)";
    }
  }

  var ticking = false;
  function onScroll() {
    check();
    if (ticking || !para.length) return;
    ticking = true;
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () { paint(); ticking = false; });
    } else {
      paint();
      ticking = false;
    }
  }

  function startPoll() {
    if (poll) return;
    var stopAt = Date.now() + 30000;
    poll = setInterval(function () {
      check();
      paint();
      if (Date.now() > stopAt) {
        clearInterval(poll);
        poll = null;
      }
    }, 300);
  }

  function arm(root) {
    var scope = root || document;
    var groups = new Map();

    scope.querySelectorAll("[data-juv-rise]").forEach(function (n) {
      /* SEPARATE guard attribute. The attribute that hides an element
         must never also be the one that says it has been handled. */
      if (n.hasAttribute("data-juv-armed")) return;
      n.setAttribute("data-juv-armed", "");
      if (!n.style.getPropertyValue("--juv-d")) {
        var parent = n.parentElement;
        var i = groups.get(parent) || 0;
        groups.set(parent, i + 1);
        n.style.setProperty("--juv-d", Math.min(i, 3) * 120 + "ms");
      }
      armed.push(n);
    });

    scope.querySelectorAll("[data-juv-parallax]").forEach(function (n) {
      if (n.hasAttribute("data-juv-px")) return;
      n.setAttribute("data-juv-px", "");
      para.push(n);
    });

    /* Same separate-guard rule as above: data-juv-watched says "this one
       is being watched", never "this one is hidden". */
    scope.querySelectorAll("[reveal-on-scroll]").forEach(function (n) {
      if (n.hasAttribute("data-juv-watched")) return;
      n.setAttribute("data-juv-watched", "");
      vendor.push(n);
    });

    check();
    paint();
    if (armed.length || para.length || vendor.length) startPoll();
  }

  function wireAccordions(root) {
    (root || document).querySelectorAll(".juv-bbacc__item").forEach(function (item) {
      if (item.hasAttribute("data-juv-acc")) return;
      item.setAttribute("data-juv-acc", "");
      var panel = item.querySelector(".juv-bbacc__panel");
      var summary = item.querySelector("summary");
      if (!panel || !summary) return;

      if (item.open) panel.style.height = panel.scrollHeight + "px";

      summary.addEventListener("click", function (e) {
        e.preventDefault();
        if (item.open) {
          panel.style.height = "0px";
          /* wait for the collapse before dropping [open], or the body
             vanishes instantly and there is nothing to animate */
          setTimeout(function () { item.open = false; }, 550);
        } else {
          item.open = true;
          panel.style.height = panel.scrollHeight + "px";
        }
      });

      window.addEventListener("resize", function () {
        if (item.open) panel.style.height = panel.scrollHeight + "px";
      }, { passive: true });
    });
  }

  function boot() {
    arm();
    wireAccordions();
    /* One guaranteed pass after the grace period even if nothing scrolls,
       resizes or polls -- the above-the-fold cards are the ones a customer
       sees first and they must not depend on an interaction. */
    setTimeout(function () { rescue(); }, GRACE_MS + 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { check(); paint(); }, { passive: true });
  document.addEventListener("shopify:section:load", function (e) {
    arm(e.target);
    wireAccordions(e.target);
  });
})();
